import {IssueRelativeTime} from '@github-ui/ago'
import {Link} from '@primer/react'

import styles from './row.module.css'

type AgoProps = {
  timestamp: Date
  linkUrl?: string
}

export function Ago({timestamp, linkUrl}: AgoProps): React.ReactElement {
  return (
    <Link href={linkUrl} className={styles.timelineAgoLink}>
      <IssueRelativeTime datetime={timestamp.toISOString()} />
    </Link>
  )
}
